// extracted by mini-css-extract-plugin
export default {"signin":"sign-in_signin__5W37a","logo":"sign-in_logo__kqEZ+","tabs":"sign-in_tabs__uAG71","add_margin":"sign-in_add_margin__UT6IT","text":"sign-in_text__k5rer"};